/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SalesBaseService } from '../sales-base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { SalesStrictHttpResponse } from '../sales-strict-http-response';

import { SalesContactLightDto } from '../models/sales-contact-light-dto';
import { SalesContactResponseDto } from '../models/sales-contact-response-dto';
import { contactsControllerAddReferent } from '../fn/contacts/contacts-controller-add-referent';
import { ContactsControllerAddReferent$Params } from '../fn/contacts/contacts-controller-add-referent';
import { contactsControllerCreate } from '../fn/contacts/contacts-controller-create';
import { ContactsControllerCreate$Params } from '../fn/contacts/contacts-controller-create';
import { contactsControllerFindAllByTenant } from '../fn/contacts/contacts-controller-find-all-by-tenant';
import { ContactsControllerFindAllByTenant$Params } from '../fn/contacts/contacts-controller-find-all-by-tenant';
import { contactsControllerFindLightByTenant } from '../fn/contacts/contacts-controller-find-light-by-tenant';
import { ContactsControllerFindLightByTenant$Params } from '../fn/contacts/contacts-controller-find-light-by-tenant';
import { contactsControllerFindOne } from '../fn/contacts/contacts-controller-find-one';
import { ContactsControllerFindOne$Params } from '../fn/contacts/contacts-controller-find-one';
import { contactsControllerRemove } from '../fn/contacts/contacts-controller-remove';
import { ContactsControllerRemove$Params } from '../fn/contacts/contacts-controller-remove';
import { contactsControllerRemoveReferent } from '../fn/contacts/contacts-controller-remove-referent';
import { ContactsControllerRemoveReferent$Params } from '../fn/contacts/contacts-controller-remove-referent';
import { contactsControllerUpdate } from '../fn/contacts/contacts-controller-update';
import { ContactsControllerUpdate$Params } from '../fn/contacts/contacts-controller-update';
import { contactsControllerUpdateReferent } from '../fn/contacts/contacts-controller-update-referent';
import { ContactsControllerUpdateReferent$Params } from '../fn/contacts/contacts-controller-update-referent';

@Injectable({ providedIn: 'root' })
export class SalesContactsService extends SalesBaseService {
  constructor(config: SalesApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactsControllerFindAllByTenant()` */
  static readonly ContactsControllerFindAllByTenantPath = '/o2-sales/contacts/{tenant}';

  /**
   * Retrieve contacts by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerFindAllByTenant$Response(params: ContactsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContactResponseDto>>> {
    const obs = contactsControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve contacts by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerFindAllByTenant(params: ContactsControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<SalesContactResponseDto>> {
    const resp = this.contactsControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesContactResponseDto>>): Array<SalesContactResponseDto> => r.body)
    );
  }

  /** Path part for operation `contactsControllerCreate()` */
  static readonly ContactsControllerCreatePath = '/o2-sales/contacts/{tenant}';

  /**
   * Create a new contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerCreate$Response(params: ContactsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
    const obs = contactsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerCreate(params: ContactsControllerCreate$Params, context?: HttpContext): Observable<SalesContactResponseDto> {
    const resp = this.contactsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContactResponseDto>): SalesContactResponseDto => r.body)
    );
  }

  /** Path part for operation `contactsControllerFindLightByTenant()` */
  static readonly ContactsControllerFindLightByTenantPath = '/o2-sales/contacts/{tenant}/light';

  /**
   * Retrieve lightweight contacts by tenant (for dropdowns/selects).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerFindLightByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerFindLightByTenant$Response(params: ContactsControllerFindLightByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContactLightDto>>> {
    const obs = contactsControllerFindLightByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve lightweight contacts by tenant (for dropdowns/selects).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerFindLightByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerFindLightByTenant(params: ContactsControllerFindLightByTenant$Params, context?: HttpContext): Observable<Array<SalesContactLightDto>> {
    const resp = this.contactsControllerFindLightByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesContactLightDto>>): Array<SalesContactLightDto> => r.body)
    );
  }

  /** Path part for operation `contactsControllerFindOne()` */
  static readonly ContactsControllerFindOnePath = '/o2-sales/contacts/{tenant}/id/{id}';

  /**
   * Retrieve a contact by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerFindOne$Response(params: ContactsControllerFindOne$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
    const obs = contactsControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a contact by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerFindOne(params: ContactsControllerFindOne$Params, context?: HttpContext): Observable<SalesContactResponseDto> {
    const resp = this.contactsControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContactResponseDto>): SalesContactResponseDto => r.body)
    );
  }

  /** Path part for operation `contactsControllerRemove()` */
  static readonly ContactsControllerRemovePath = '/o2-sales/contacts/{tenant}/{id}';

  /**
   * Delete a contact by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerRemove$Response(params: ContactsControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
    const obs = contactsControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a contact by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerRemove(params: ContactsControllerRemove$Params, context?: HttpContext): Observable<SalesContactResponseDto> {
    const resp = this.contactsControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContactResponseDto>): SalesContactResponseDto => r.body)
    );
  }

  /** Path part for operation `contactsControllerUpdate()` */
  static readonly ContactsControllerUpdatePath = '/o2-sales/contacts/{tenant}/{id}';

  /**
   * Update a contact by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerUpdate$Response(params: ContactsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
    const obs = contactsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a contact by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerUpdate(params: ContactsControllerUpdate$Params, context?: HttpContext): Observable<SalesContactResponseDto> {
    const resp = this.contactsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContactResponseDto>): SalesContactResponseDto => r.body)
    );
  }

  /** Path part for operation `contactsControllerAddReferent()` */
  static readonly ContactsControllerAddReferentPath = '/o2-sales/contacts/{tenant}/{id}/referents';

  /**
   * Add a referent to a contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerAddReferent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerAddReferent$Response(params: ContactsControllerAddReferent$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
    const obs = contactsControllerAddReferent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a referent to a contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerAddReferent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerAddReferent(params: ContactsControllerAddReferent$Params, context?: HttpContext): Observable<SalesContactResponseDto> {
    const resp = this.contactsControllerAddReferent$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContactResponseDto>): SalesContactResponseDto => r.body)
    );
  }

  /** Path part for operation `contactsControllerRemoveReferent()` */
  static readonly ContactsControllerRemoveReferentPath = '/o2-sales/contacts/{tenant}/{id}/referents/{referentEmail}';

  /**
   * Remove a referent from a contact by email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerRemoveReferent()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerRemoveReferent$Response(params: ContactsControllerRemoveReferent$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
    const obs = contactsControllerRemoveReferent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a referent from a contact by email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerRemoveReferent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsControllerRemoveReferent(params: ContactsControllerRemoveReferent$Params, context?: HttpContext): Observable<SalesContactResponseDto> {
    const resp = this.contactsControllerRemoveReferent$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContactResponseDto>): SalesContactResponseDto => r.body)
    );
  }

  /** Path part for operation `contactsControllerUpdateReferent()` */
  static readonly ContactsControllerUpdateReferentPath = '/o2-sales/contacts/{tenant}/{id}/referents/{referentEmail}';

  /**
   * Update a referent in a contact by email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsControllerUpdateReferent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerUpdateReferent$Response(params: ContactsControllerUpdateReferent$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
    const obs = contactsControllerUpdateReferent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a referent in a contact by email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsControllerUpdateReferent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactsControllerUpdateReferent(params: ContactsControllerUpdateReferent$Params, context?: HttpContext): Observable<SalesContactResponseDto> {
    const resp = this.contactsControllerUpdateReferent$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContactResponseDto>): SalesContactResponseDto => r.body)
    );
  }

}
